import algoliasearch from "algoliasearch";
import { format as formatDate } from "date-fns";
import { fetchSnap } from "../common/utils";

import ModalArticle from "../sections/modal-2023-article";
const modalArticle = ModalArticle();

import ModalSnap from "../sections/modal-2023-snap";
const modalSnap = ModalSnap();

const SPEEDSIZE_PREFIX = "https://sfycdn.speedsize.com/a0aebe60-8b13-4e95-8aca-b006a78ac89f/";

const initializeMediaGrid2023 = () => {
  renderArticles();
  renderSnaps();
};

const renderArticles = () => {
  let ids = [];
  document.querySelectorAll(".media-grid-2023-article").forEach((el) => {
    ids.push(el.dataset["articleId"]);
  });
  if (ids.length <= 0) {
    return;
  }
  const client = algoliasearch("ZGISPFZEQK", "0127e1a89a00ce11a21a8a03c69e5ae9");
  const entries = client.initIndex("entries");
  entries
    .getObjects(ids)
    .then((response) => {
      if (!window.fstore.mediaCache) {
        window.fstore.mediaCache = {};
      }
      if (!window.fstore.mediaCache.articles) {
        window.fstore.mediaCache.articles = [];
      }
      window.fstore.mediaCache.articles = window.fstore.mediaCache.articles.concat(response.results);
      response.results.forEach((article) => renderArticle(article));
    })
    .catch((error) => {});
};

const renderArticle = (article) => {
  document.querySelectorAll(`.media-grid-2023-article[data-article-id="${article.objectID}"]`).forEach((el) => {
    let mediaTag = `<img
         src="${SPEEDSIZE_PREFIX}${article.thumbnail.normal.replace("w_150", "w_800").replace("width=150", "width=800")}"
         width="${article.thumbnail.width}"
         height=${article.thumbnail.height}"
         alt="${article.title}"
       />`;
    if (0 < el.dataset.articleVideoUrl.trim().length) {
      mediaTag = `<video src="${el.dataset.articleVideoUrl}" alt="${article.title}" muted loop autoplay />`;
    }

    const html = `
      <div class="fs-image">
        ${mediaTag}
      </div>
      <div class="fs-texts">
        <p class="fs-title">${article.title}</p>
        <p class="fs-date">${formatDate(article.date * 1000, "yyyy.MM.dd")}</p>
      </div>
    `;
    el.innerHTML = html;
    el.addEventListener("click", (e) => {
      if (e.target.tagName == "A") {
        return;
      }
      modalArticle.showModalArticle(article.objectID);
    });
  });
};

const renderSnaps = () => {
  let ids = [];
  document.querySelectorAll(".media-grid-2023-snap").forEach((el) => {
    ids.push(el.dataset["snapId"]);
  });
  if (ids.length <= 0) {
    return;
  }
  const params = {
    articleIds: ids,
  };
  fetchSnap(params)
    .then((response) => {
      if (!window.fstore.mediaCache) {
        window.fstore.mediaCache = {};
      }
      if (!window.fstore.mediaCache.snaps) {
        window.fstore.mediaCache.snaps = [];
      }
      window.fstore.mediaCache.snaps = window.fstore.mediaCache.snaps.concat(response);
      response.forEach((snap) => renderSnap(snap));
    })
    .catch((error) => {});
};

const renderSnap = (snap) => {
  const items = snap.items
    .slice(0, 2)
    .map((item) => `<p class="fs-text">${item.key}：${item.value}</p>`)
    .join("");
  document.querySelectorAll(`.media-grid-2023-snap[data-snap-id="${snap.articleId}"]`).forEach((el) => {
    const html = `
      <div class="fs-image">
        <img
          src="${SPEEDSIZE_PREFIX}${snap.image.url.replace("width=1500", "width=600")}"
          width="600"
          height="${(snap.image.height / snap.image.width) * 600}"
          alt="${snap.model.name}"
        />
      </div>
      <div class="fs-texts">
        <p class="fs-snap-title">SNAP</p>
        ${items}
      </div>
    `;
    el.innerHTML = html;
    el.addEventListener("click", (e) => {
      if (e.target.tagName == "A") {
        return;
      }
      modalSnap.showModalSnap(snap.articleId);
    });
  });
};

/*
 * Main
 */

const mediaGrid2023Main = () => {
  if (location.pathname != "/") {
    return;
  }
  initializeMediaGrid2023();
};

mediaGrid2023Main();
